import React, {useRef, useState, useEffect} from 'react';
import PageHeader1 from '../../components/common/PageHeader1';
import {useNavigate} from "react-router-dom";
import {Button, Spinner} from "react-bootstrap";
import apiClient from "../../utils/api";

function RolesAdd() {
    const navigate = useNavigate()
    const [formData, setFormData] = useState({
        name: '',
        permissions: []
    });
    const [permissions, setPermissions] = useState([]);
    const [loading, setLoading] = useState(true);

    const handleInputChange = (e) => {
        const {name, value, checked} = e.target;
        if (name === "permissions") {
            setFormData((prevState) => {
                const updatedPermissions = checked
                    ? [...prevState.permissions, value]
                    : prevState.permissions.filter((key) => key !== value);

                return {...prevState, [name]: updatedPermissions};
            });
        } else {
            setFormData({...formData, [name]: value});
        }
    };

    useEffect(() => {
        // Fetch permissions from API
        const fetchPermissions = async () => {
            try {
                const token = localStorage.getItem('auth_token');
                const response = await apiClient.get('/permissions', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                
                if (response.data && response.data.status === 'success') {
                    setPermissions(response.data.data);
                }
            } catch (error) {
                console.error('Error fetching permissions:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPermissions();
    }, []);

    const onSubmit  = async (e) => {
        e.preventDefault();
        //setLoading(true)
        const data = new FormData();
        data.append('name', formData.name);

        formData.permissions.forEach(permission => {
            data.append('permissions[]', permission);
        });

        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.post('accounts/roles', data,{
                headers: { Authorization: `Bearer ${token}` }
            });
            //toast.success(response.data.message);
            navigate(process.env.PUBLIC_URL+'/accounts/roles-list');

        } catch (error) {
            //toast.error('Error adding product');
        } finally {
           // setLoading(false);
        }
    }


    return (
        <div className="container-xxl">
            <form onSubmit={onSubmit}>
                <PageHeader1 pagetitle='Role Add' button={true}/>
                <div className="row g-3">
                    {/*<div className="col-xl-3 col-lg-3">
                        <div className="sticky-lg-top">
                            <div className="card mb-3">
                                <ActiveStatus
                                    onStatusChange={handleInputChange}
                                    checked={formData.is_active}
                                    name="is_active"
                                />
                            </div>
                        </div>
                    </div>*/}
                    <div className="col-xl-12 col-lg-12">
                        <div className="card mb-3">
                            <div
                                className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                                <h6 className="mb-0 fw-bold ">Basic information</h6>
                            </div>
                            <div className="card-body">
                                <form>
                                    <div className="row g-3 align-items-center">
                                        <div className="col-md-12">
                                            <label className="form-label">Name</label>
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                            />
                                        </div>                                        <div className="col-md-12">
                                            <h4 className="form-label">Permissions Flags</h4>                                            {loading ? (
                                                <div className="d-flex justify-content-center">
                                                    <Spinner animation="border" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </Spinner>
                                                </div>
                                            ) : (
                                                permissions.map((group, index) => (
                                                    <div key={index} style={{ marginBottom: "20px" }}>
                                                        <label style={{ fontWeight: "bold", marginBottom: "5px" }}>{group.parent}</label>
                                                        <div style={{ marginLeft: "20px" }}>
                                                            {group.children.map((child, childIndex) => (
                                                                <div key={childIndex}>
                                                                    <input
                                                                        name="permissions"
                                                                        style={{ width: "15px", height: "15px" }}
                                                                        type="checkbox"
                                                                        id={child}
                                                                        value={child}
                                                                        checked={formData.permissions.includes(child)}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                    <label htmlFor={child} style={{ marginLeft: "8px" }}>
                                                                        {child}
                                                                    </label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default RolesAdd;